import { AxiosRequestConfig } from 'axios'

import { getFileRequirement, postSuscriptionDocuments, getFileTerms, postCollaboratorConfirmationConfirm, getDashboard } from 'services/api'
import { isSuccessStatus } from 'utils/functions/validations'
import { IFetchedGetDashborad, IGetDashborad } from 'services/IApi.d'

const idEmpresa = localStorage.getItem('idEmpresa')
const idSuscriptor = localStorage.getItem('idSuscriptor')
const idRepresentante = localStorage.getItem('idRepresentante')
const companyCuit = localStorage.getItem('companyCuit')


export const getResumenStatus = async (subscriptorId, companyId): Promise<IGetDashborad> => {
    const response: IFetchedGetDashborad = await getDashboard(subscriptorId, companyId)
    if (!isSuccessStatus(response.status)) {
      throw new Error('PlanAccountsContext must be used within a PlanAccounts') 
    }
    return response.data
}

export const getFileData = async (executeRecaptcha?: (action?: string) => Promise<string>) => {
    const token: string = await executeRecaptcha('technical_requirements')
    const docs = async (): Promise<any> => {
      const headers: AxiosRequestConfig<unknown> = { headers: { 'x-recaptcha-token': token } }      
      const response: any = await getFileRequirement({ companyCuit, collaboratorId: idRepresentante }, headers)
      return response
    }
    docs().then(res => {
      if (isSuccessStatus(res.status)) {
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'file.zip')
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(link)
      }
    })
}

export const getFileTermsConditionData = async (executeRecaptcha?: (action?: string) => Promise<string>) => {
    const token: string = await executeRecaptcha('terms_and_conditions')
    const docs = async (): Promise<any> => {
      const headers: AxiosRequestConfig<unknown> = { headers: { 'x-recaptcha-token': token } }
      const response = await getFileTerms({ companyCuit, collaboratorId: idRepresentante }, headers)
      return response
    }
    docs().then(res => {
      if (isSuccessStatus(res.status)) {
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'file.zip')
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(link)
      }
    })
}


export const getDocumentsDownloadData = async () => {
  const postSubscriptionDocs = async (): Promise<any> => {
      const response = await postSuscriptionDocuments(idSuscriptor, idEmpresa)
      return response
    }

  postSubscriptionDocs().then(res => {
      if (isSuccessStatus(res.status)) {
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'file.zip')
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(link)
      }
    })
}

export const confirmData = async (executeRecaptcha?: (action?: string) => Promise<string>): Promise<boolean> => {
    const token: string = await executeRecaptcha('legal_representative')
    const header: AxiosRequestConfig<unknown> = { headers: { 'x-recaptcha-token': token } }
    const response = await postCollaboratorConfirmationConfirm({ collaboratorId: idRepresentante, companyId: idEmpresa, subscriberId: idSuscriptor }, header)
    return isSuccessStatus(response.status)
}
